import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import Homepage from '../components/HomepageLanding';
import { MetaTagsComp } from '../components/MetaTagsComp';
import fetchUtil from '../utils/fetchUtil';

const Home: NextPage = (props: any) => {
  const { meta } = props.homePageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#226CF5');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <Homepage {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const homePageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/home`, 'GET', {}, '', false)
  return {
    props: {
      homePageData,
    }
  };
}

export default Home
